import { RadioGroup } from "@headlessui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button, SubmitButton } from "@/components/Interface/Button/Button";
import { ProfileCard } from "@/components/Layout/BaseLayouts/ProfileCard/ProfileCard";
import {
  AuthenticatorSetupFormElements,
  AuthenticatorSetupMethodsForm,
} from "@/components/Welcome/AuthenticatorSetup/AuthenticatorSetupForm";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { ChangeTwoFactorAuthenticationMethod } from "@/services/model";

export const TwoFactorInitialSetupForm = () => {
  const { t } = useTranslation();
  const { handleSubmit, watch, setValue } =
    useForm<AuthenticatorSetupMethodsForm>({
      // This form is only reached while 2FA is disabled (STANDARD), so that's
      // the correct preselected option.
      defaultValues: { type: ChangeTwoFactorAuthenticationMethod.STANDARD },
    });
  const navigate = useNavigate();

  const onSubmit = (data: AuthenticatorSetupMethodsForm) => {
    // Handle form submission
    if (data.type === ChangeTwoFactorAuthenticationMethod.APP) {
      // Handle APP setup
      navigate(portalRoutes.user.security.initialAppSetup);
    }
    if (data.type === ChangeTwoFactorAuthenticationMethod.SMS) {
      // Handle SMS setup
      navigate(portalRoutes.user.security.initialSmsSetup);
    }
    if (data.type === ChangeTwoFactorAuthenticationMethod.STANDARD) {
      // Handle LOGIN setup
      navigate(portalRoutes.user.security.base);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ProfileCard
        maxWidth="none"
        title={t("portal:user-account.security.2fa.initialSetup.title")}
        actions={
          <>
            <Button
              variant="secondary"
              size="sm"
              type="button"
              onClick={() => navigate(portalRoutes.user.security.base)}
            >
              {t("portal:user-account.security.buttons.cancel")}
            </Button>
            <SubmitButton
              fullWidth={false}
              size="sm"
              label={t("portal:user-account.security.buttons.continue")}
            />
          </>
        }
      >
        <RadioGroup
          value={watch("type")}
          onChange={(type: ChangeTwoFactorAuthenticationMethod) =>
            setValue("type", type)
          }
          className="flex flex-col gap-4"
          aria-label={t("portal:user-account.security.2fa.initialSetup.title")}
        >
          <AuthenticatorSetupFormElements compact />
        </RadioGroup>
      </ProfileCard>
    </form>
  );
};
